module.exports = __webpack_public_path__ + "static/media/practice-demonstration.ae9a54de.svg";